import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = 'https://besor3a.com/api';

export default function DriverProfile({ driver, token, onBack }) {
  const [tab, setTab] = useState('overview');
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    axios.get(`${API}/orders?driver_id=${driver.id}&limit=100`)
      .then(r => setOrders(r.data.orders || []))
      .finally(() => setLoading(false));
  }, [driver.id, token]);

  const delivered = orders.filter(o => o.status === 'delivered');
  const cancelled = orders.filter(o => o.status === 'cancelled');
  const rated = delivered.filter(o => o.client_rating);
  const avgRating = rated.length ? (rated.reduce((s,o) => s + o.client_rating, 0) / rated.length).toFixed(1) : null;
  const totalRevenue = delivered.reduce((s,o) => s + parseFloat(o.base_price||0), 0);

  return (
    <div style={{direction:'rtl',minHeight:'100vh',background:'#f5f6fa'}}>
      <div style={{background:'linear-gradient(135deg,#667eea,#764ba2)',padding:'20px 20px 40px'}}>
        <button onClick={onBack} style={{background:'rgba(255,255,255,0.2)',border:'none',color:'#fff',padding:'8px 16px',borderRadius:'20px',cursor:'pointer',marginBottom:'16px',fontSize:'13px'}}>← رجوع</button>
        <div style={{textAlign:'center',color:'#fff'}}>
          <div style={{width:'80px',height:'80px',borderRadius:'50%',background:'rgba(255,255,255,0.2)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'36px',margin:'0 auto 12px'}}>🛵</div>
          <h2 style={{margin:'0 0 4px',fontSize:'22px',fontWeight:'900'}}>{driver.full_name}</h2>
          <p style={{margin:'0 0 4px',fontSize:'14px',opacity:0.8}}>{driver.vehicle_type} • {driver.vehicle_plate}</p>
          <p style={{margin:0,fontSize:'14px',opacity:0.8}}>{driver.phone}</p>
        </div>
      </div>

      <div style={{margin:'-20px 16px 16px',display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'10px'}}>
        {[['⭐',avgRating||'—','التقييم'],['✅',delivered.length,'مكتمل'],['💰',totalRevenue.toFixed(0)+' ج','الإيرادات']].map(([ic,n,lb])=>(
          <div key={lb} style={{background:'#fff',borderRadius:'14px',padding:'14px',textAlign:'center',boxShadow:'0 4px 15px rgba(0,0,0,0.08)'}}>
            <p style={{margin:'0 0 4px',fontSize:'22px'}}>{ic}</p>
            <p style={{margin:'0 0 2px',fontSize:'18px',fontWeight:'bold',color:'#1a1a2e'}}>{n}</p>
            <p style={{margin:0,fontSize:'11px',color:'#888'}}>{lb}</p>
          </div>
        ))}
      </div>

      <div style={{margin:'0 16px 16px',display:'flex',gap:'8px'}}>
        {[['overview','📊','نظرة عامة'],['trips','🚀','الرحلات'],['ratings','⭐','التقييمات']].map(([id,ic,lb])=>(
          <button key={id} onClick={()=>setTab(id)} style={{flex:1,padding:'10px 6px',borderRadius:'12px',border:'2px solid',borderColor:tab===id?'#667eea':'#ddd',background:tab===id?'#667eea':'#fff',color:tab===id?'#fff':'#666',cursor:'pointer',fontSize:'12px',fontWeight:'bold'}}>
            {ic} {lb}
          </button>
        ))}
      </div>

      <div style={{margin:'0 16px',paddingBottom:'30px'}}>
        {loading && <p style={{textAlign:'center',color:'#888',padding:'40px'}}>⏳ جاري التحميل...</p>}

        {!loading && tab === 'overview' && (
          <div>
            <div style={{background:'#fff',borderRadius:'14px',padding:'16px',marginBottom:'12px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
              <h4 style={{margin:'0 0 12px',color:'#333'}}>📋 بيانات الطيار</h4>
              {[['الاسم',driver.full_name],['الهاتف',driver.phone],['المركبة',driver.vehicle_type],['اللوحة',driver.vehicle_plate||'—'],['الحالة',driver.status],['التوفر',driver.availability]].map(([l,v])=>(
                <div key={l} style={{display:'flex',justifyContent:'space-between',padding:'8px 0',borderBottom:'1px solid #f5f5f5',fontSize:'14px'}}>
                  <span style={{color:'#888'}}>{l}</span>
                  <span style={{fontWeight:'bold',color:'#333'}}>{v}</span>
                </div>
              ))}
            </div>
            <div style={{background:'#fff',borderRadius:'14px',padding:'16px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
              <h4 style={{margin:'0 0 12px',color:'#333'}}>📈 إحصائيات</h4>
              {[['إجمالي الرحلات',orders.length],['رحلات مكتملة',delivered.length],['رحلات ملغية',cancelled.length],['رحلات مقيمة',rated.length],['متوسط التقييم',avgRating?`${avgRating}/5 ⭐`:'لا يوجد'],['إجمالي الإيرادات',`${totalRevenue.toFixed(2)} ج`]].map(([l,v])=>(
                <div key={l} style={{display:'flex',justifyContent:'space-between',padding:'8px 0',borderBottom:'1px solid #f5f5f5',fontSize:'14px'}}>
                  <span style={{color:'#888'}}>{l}</span>
                  <span style={{fontWeight:'bold',color:'#667eea'}}>{v}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {!loading && tab === 'trips' && (
          <div>
            {orders.length === 0 ? (
              <p style={{textAlign:'center',color:'#888',padding:'40px'}}>لا توجد رحلات</p>
            ) : orders.map(o => (
              <div key={o.id} style={{background:'#fff',borderRadius:'14px',padding:'16px',marginBottom:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
                <div style={{display:'flex',justifyContent:'space-between',marginBottom:'8px'}}>
                  <span style={{fontSize:'12px',color:'#888'}}>{new Date(o.requested_at).toLocaleDateString('ar-EG')}</span>
                  <span style={{fontSize:'12px',fontWeight:'bold',padding:'3px 10px',borderRadius:'20px',background:o.status==='delivered'?'#d1fae5':o.status==='cancelled'?'#fee2e2':'#fef3c7',color:o.status==='delivered'?'#065f46':o.status==='cancelled'?'#7f1d1d':'#92400e'}}>
                    {o.status==='delivered'?'✅ مكتمل':o.status==='cancelled'?'❌ ملغي':'⏳ جاري'}
                  </span>
                </div>
                <p style={{margin:'0 0 4px',fontSize:'13px',color:'#333'}}>📍 {(o.pickup_address||'').substring(0,40)}</p>
                <p style={{margin:'0 0 8px',fontSize:'13px',color:'#333'}}>🏁 {(o.dropoff_address||'').substring(0,40)}</p>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                  <span style={{fontSize:'15px',fontWeight:'bold',color:'#667eea'}}>{o.base_price} ج</span>
                  {o.client_rating && <span style={{fontSize:'13px',color:'#f59e0b'}}>{'⭐'.repeat(o.client_rating)} ({o.client_rating}/5)</span>}
                </div>
              </div>
            ))}
          </div>
        )}

        {!loading && tab === 'ratings' && (
          <div>
            <div style={{background:'#fff',borderRadius:'14px',padding:'20px',marginBottom:'12px',textAlign:'center',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
              <p style={{margin:'0 0 4px',fontSize:'48px',fontWeight:'bold',color:'#1a1a2e'}}>{avgRating||'—'}</p>
              <p style={{margin:'0 0 8px',fontSize:'24px'}}>{'⭐'.repeat(Math.round(avgRating||0))}</p>
              <p style={{margin:0,fontSize:'14px',color:'#888'}}>بناءً على {rated.length} تقييم</p>
              <div style={{display:'flex',justifyContent:'center',gap:'20px',marginTop:'16px'}}>
                {[5,4,3,2,1].map(s=>{
                  const count = rated.filter(o=>o.client_rating===s).length;
                  const pct = rated.length ? (count/rated.length*100).toFixed(0) : 0;
                  return (
                    <div key={s} style={{textAlign:'center'}}>
                      <p style={{margin:'0 0 4px',fontSize:'13px',color:'#f59e0b'}}>{s}⭐</p>
                      <p style={{margin:0,fontSize:'16px',fontWeight:'bold'}}>{count}</p>
                    </div>
                  );
                })}
              </div>
            </div>
            {rated.length === 0 ? (
              <p style={{textAlign:'center',color:'#888',padding:'40px'}}>لا توجد تقييمات بعد</p>
            ) : rated.map(o => (
              <div key={o.id} style={{background:'#fff',borderRadius:'14px',padding:'16px',marginBottom:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
                <div style={{display:'flex',justifyContent:'space-between',marginBottom:'8px'}}>
                  <span style={{fontSize:'12px',color:'#888'}}>{new Date(o.requested_at).toLocaleDateString('ar-EG')}</span>
                  <span style={{fontSize:'16px',color:'#f59e0b'}}>{'⭐'.repeat(o.client_rating)}</span>
                </div>
                {o.client_review && <p style={{margin:'0 0 4px',fontSize:'13px',color:'#333',fontStyle:'italic'}}>"{o.client_review}"</p>}
                <p style={{margin:0,fontSize:'12px',color:'#888'}}>📍 {(o.pickup_address||'').substring(0,35)}...</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
